import { FC } from 'react'
import { caseDetailGrid } from '../../theme/styleConstants'
import { FormHelperText, Grid, Tooltip, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { InfoOutlined } from '@mui/icons-material'

export const CaseDetailRow: FC<{
  title: string
  content: string | JSX.Element
  note?: string
  tooltip?: string
  action?: JSX.Element
  to?: string
  maxWidth?: number
}> = ({ title, content, action, note, tooltip, to, maxWidth }) => (
  <Grid container sx={caseDetailGrid}>
    <Grid item md={6} sm={12} xs={12}>
      <Typography
        variant="h6"
        className="CaseDetail-Title"
        width={'auto !important'}
        display="flex"
        alignItems="center"
        gap={0.5}
        sx={{ overflowWrap: 'anywhere' }}
      >
        {title}
        {tooltip && (
          <Tooltip title={tooltip} arrow placement="top">
            <InfoOutlined sx={{ fontSize: '15px', cursor: 'help', color: 'grayText' }} />
          </Tooltip>
        )}
      </Typography>
    </Grid>

    <Grid container item md={6} sm={12} xs={12} direction="column">
      <Grid item display="flex" alignItems="center" gap={5} flexWrap="wrap">
        <Typography
          variant="h6"
          className={to ? 'CaseDetail-SubTitle-Link' : 'CaseDetail-SubTitle'}
          component={to ? Link : 'span'}
          to={to}
          sx={{
            maxWidth: maxWidth ?? '100%',
            minWidth: 0,
            display: 'block',
            whiteSpace: 'normal',
            overflow: 'visible',
            textOverflow: 'unset',
            overflowWrap: 'anywhere',
            wordBreak: 'break-word'
          }}
          title={typeof content === 'string' ? content : undefined}
        >
          {content}
        </Typography>
        {action && action}
      </Grid>

      {note && (
        <Grid item display="flex" alignItems="center" gap={0.5}>
          <InfoOutlined sx={{ fontSize: '14px' }} />
          <FormHelperText>{note}</FormHelperText>
        </Grid>
      )}
    </Grid>
  </Grid>
)
